import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionVehiclePhotos = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`vehiclePhotos-${sessionId}`, [])
);

export const vehiclePhotosAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionVehiclePhotos);

export const has4PhotosUploadedAtom = atom((get) => get(vehiclePhotosAtom).length === 4);
